<template>
    <div class="row" style="margin:0px;max-height:85vh;text-align:center">
        <div class="col-md-12" style="text-align:center">
            <div v-show="pwd" class="alert alert-secondary alert-dismissible fade show" role="alert" style="background-color: #d1eaec !important;text-align:center">
                {{passwordmessage}}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>   
        </div>
        <div class="form-group" style="text-align:left;margin-top: 0.5vw;width:90%">
                <div class="form-group">
                    <label  class="control-label card-form-label" for="exampleFormControlInput1">Password</label>
                    <md-field style="margin-bottom:2px;">
                        <md-input type="password" id="fortext" class="form-control"  placeholder="" v-model="password" name="password"></md-input>
                    </md-field>
                </div>
                <div class="form-group">
                    <label  class="control-label card-form-label" for="exampleFormControlInput1">Confirm Password</label>
                    <md-field style="margin-bottom:2px;">
                        <md-input type="password" id="fortext" class="form-control"  placeholder="" v-model="password1" name="password1"></md-input>
                    </md-field>
                </div>
                <div style="margin-top:20px;">
                <button class="btn cncel_btn" @click="closePassModal()">Cancel</button>
                <button class="btn update_btn" @click="resetpass()">Change</button>
                </div>
        </div>
    </div>
</template>



<script>
require('@/assets/css/new.css')
import axios from 'axios';
import { EventBus } from '../event-bus.js'

export default {
    name : "ResetPassword",
    data(){
        return {
            password:"",
            password1:'',
            passwordmessage:false,
            pwd:false,
        }
    },
    computed : {
        passDisabled(){
            this.pwd = false
            if(this.password)
                if(this.password.length >= 8){
                if(this.password == this.password1){
                    this.pwd = false
                    return false
                }else if(this.password != this.password1 && this.password1.length > 0){
                    this.pwd = true
                    this.passwordmessage = "Passwords don't match"
                    return true
                }
            }else{
                this.pwd = true
                this.passwordmessage ="Password should be atleast 8 characters long"
                return true
            }
        }
    },
    created(){
        
    },
    methods : {
        resetpass(){
            if (this.password != "" && this.password != undefined){
                this.error = false
                this.codeerror = false
                axios.post('/resetpassword?password=' + this.password)
                    .then(res => {
                    if (res.data.value !== null && res.data.value !== 1) {
                        this.ShowToast("Success", 'Password has been reset successfully.', "primary")
                        this.closePassModal()
                    } else {
                        this.pwd = true
                        this.passwordmessage = "Error while resetting password. Please try later."
                    }
                })
            }else{
                this.pwd = true
                this.passwordmessage ="Password should be atleast 8 characters long"
            }
        },
        signout(){
            this.$router.push('/')
            EventBus.$emit('logout', "true")
        },
        closePassModal(){
            EventBus.$emit('closePassModal', "true")
        },
        ShowToast(header, body, color){
            this.$bvToast.toast(body, {
                title: header,
                variant: color,
                solid: true,
                toaster: 'b-toaster-top-center'
            })
        },
    }
}
</script>

<style>
.card-css{
    bottom:0vh;
    border-radius: 8px;
    box-shadow: 0px 1px 5.8px 0.2px rgba(0, 0, 0, 0.19);
    background-color: #ffffff;
}
.cncel_btn {
    background-color: #e6efee;
    border: solid 1px #9cbcbe !important;
    color: #073c49 !important;
    font-size: 15px;
    margin-right:10px;
}
.update_btn {
    background-color: #529da3 !important;
    color: #ffffff !important;
    font-size: 15px;
}
input[class=search-form]:focus {
    box-shadow: none !important;
    border-color: aliceblue !important;
    border-right:none !important;
}
.md-field.md-theme-default[data-v-026d09f4]:before {
    background-color: #073c49!important;
}

</style>
